import { fork, put, call, take } from 'redux-saga/effects';

import { acceptError } from 'common/_redux';
import { REQUEST } from 'redux-config/reduxHelpers';

import * as api from '../api';
import * as ActionTypes from './actions';

function* updateBrokerColorSchemaSaga({ payload }) {
  try {
    yield call(api.updateBrokerColorSchema, payload.data, payload.brand);
    yield put(ActionTypes.updateBrokerColorSchema.success());
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.updateBrokerColorSchema.failure(e));
  }
}

function* updateBrokerColorSchemaWatcherSaga() {
  while (true) {
    const values = yield take(ActionTypes.updateBrokerColorSchema.REQUEST);
    yield call(updateBrokerColorSchemaSaga, values);
  }
}

function* getBrokerColorSchemaSaga({ brand }) {
  try {
    const { data } = yield call(api.getBrokerColorSchema, brand);
    yield put(ActionTypes.getBrokerColorSchema.success(data));
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getBrokerColorSchema.failure(e));
  }
}

function* getBrokerColorSchemaWatcherSaga() {
  while (true) {
    const data = yield take(ActionTypes.GET_BROKER_COLOR_SCHEMA[REQUEST]);
    yield call(getBrokerColorSchemaSaga, data);
  }
}

function* getCustomizationBrandsSaga() {
  try {
    const { data } = yield call(api.getCustomizationBrands);
    yield put(ActionTypes.getCustomizationBrands.success(data));
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getCustomizationBrands.failure(e));
  }
}

function* getCustomizationBrandsWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_CUSTOMIZATION_BRANDS[REQUEST]);
    yield call(getCustomizationBrandsSaga);
  }
}

export default [
  fork(updateBrokerColorSchemaWatcherSaga),
  fork(getBrokerColorSchemaWatcherSaga),
  fork(getCustomizationBrandsWatcherSaga),
];
